import { activeAnnouncementSchema } from "@studyward/shared";
import { useQuery } from "@tanstack/react-query";
import { Megaphone, X } from "lucide-react";
import { useState } from "react";
import { api } from "../lib/api";

const DISMISSED_KEY = "sw.dismissed-announcement";

function readDismissed(): string | null {
  try {
    return sessionStorage.getItem(DISMISSED_KEY);
  } catch {
    return null;
  }
}

/** The live banner from Admin → Announcements (§10.3 #8), for this student's plan and programme. Dismissable per visit. */
export function AnnouncementBanner() {
  const query = useQuery({ queryKey: ["announcement"], queryFn: () => api.get("/announcements/active?surface=web", activeAnnouncementSchema), staleTime: 60_000, refetchInterval: 5 * 60_000 });
  const [dismissed, setDismissed] = useState(readDismissed);
  const a = query.data?.announcement;
  if (!a || dismissed === a.id) return null;
  return (
    <div role="status" className="mb-4 flex items-start gap-3 rounded-card bg-surface-navy px-5 py-4 text-small font-semibold text-surface-background">
      <Megaphone size={18} aria-hidden="true" className="mt-0.5 shrink-0" />
      <p className="flex-1">{a.message}</p>
      <button
        type="button"
        aria-label="Dismiss announcement"
        className="-m-2 grid size-9 shrink-0 place-items-center rounded-pill hover:bg-surface-background/20"
        onClick={() => {
          setDismissed(a.id);
          try {
            sessionStorage.setItem(DISMISSED_KEY, a.id);
          } catch {
            // Private mode: the banner simply returns on the next visit.
          }
        }}
      >
        <X size={18} aria-hidden="true" />
      </button>
    </div>
  );
}
